<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'page-culture-inventory',
};
</script>




// WEBPACK FOOTER //
// src/pages/inventory/page-inventory.vue